export default {"src":"/_next/static/media/edomex.c9cee859.svg","height":83,"width":85,"blurWidth":0,"blurHeight":0};